import * as React from 'react';
import * as adminStyles from '../AdminStyles.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IATextField } from '../../../textField/TextField';
import { IADropDown } from '../../../dropDown/DropDown';
import { IAIconPicker } from '../../../iconPicker/IconPicker';
import { IASiteSelector } from '../../../siteSelector/SiteSelector';
import { IContentOrganizerCreate } from '../../../../interfaces/IContentOrganizerCreate';

export interface ITopItemSettingsAiConfigurationProps {
  navigatorStore?: NavigatorStore;
  selectedTopItem: any;
}

export interface ITopItemSettingsAiConfigurationState {
}

@inject('navigatorStore')
@observer
export default class TopItemSettingsAiConfiguration extends React.Component<ITopItemSettingsAiConfigurationProps, ITopItemSettingsAiConfigurationState> {

  private localizationService = new LocalizationService();

  constructor(props: ITopItemSettingsAiConfigurationProps) {
    super(props);
    this.state = {
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }


  public render(): JSX.Element {
    return <>
      <IATextField
        label={this.localizationService.strings.Navigator_Content_AiTitle}
        placeholder={this.localizationService.strings.Navigator_Content_AiTitleFallback}
        text={this.props.selectedTopItem.config.instance.aiCustomTitle}
        borderRadius={5}
        onChange={(title: string) => {
          this.props.selectedTopItem.config.instance.aiCustomTitle = title;
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
      />
      <IATextField
        label={this.localizationService.strings.Navigator_Content_AiExample}
        placeholder={this.localizationService.strings.Navigator_Content_AiExampleFallback}
        text={this.props.selectedTopItem.config.instance.aiCustomExample}
        borderRadius={5}
        onChange={(example: string) => {
          this.props.selectedTopItem.config.instance.aiCustomExample = example;
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
      />
      <div className={adminStyles.panelDivider} />
      <IATextField
        label={this.localizationService.strings.Navigator_Content_AiDescriptionHeadline ?? "Description headline (optional)"}
        text={this.props.selectedTopItem.config.instance.aiCustomHeadline}
        borderRadius={5}
        onChange={(headline: string) => {
          this.props.selectedTopItem.config.instance.aiCustomHeadline = headline;
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
      />
      <IAIconPicker
        label={this.localizationService.strings.Navigator_Content_AiDescriptionIcon ?? "Description icon (optional)"}
        selectedIcon={this.props.selectedTopItem.config.instance.aiCustomIconUrl ? this.props.selectedTopItem.config.instance.aiCustomIconUrl : undefined}
        color={this.props.navigatorStore.highlightColor}
        select={(iconUrl: string) => {
          this.props.selectedTopItem.config.instance.aiCustomIconUrl = iconUrl;
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
        shouldBeAbleToClear={false}
        clear={() => { }}
      />
      <IATextField
        label={this.localizationService.strings.Navigator_Content_AiDescription ?? "Description text (optional)"}
        text={this.props.selectedTopItem.config.instance.aiCustomDescription}
        borderRadius={5}
        onChange={(description: string) => {
          this.props.selectedTopItem.config.instance.aiCustomDescription = description;
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
      />
      <div className={adminStyles.panelDivider} />
      <IADropDown
        label={this.localizationService.strings.Navigator_Content_AiContentLanguage}
        selectedOption={this.props.selectedTopItem?.config?.instance?.aiContentLanguage ?? undefined}
        options={[
          {
            key: "en",
            value: this.localizationService.strings.Navigator_Admin_ContentOnlyInEnglish,
          },
          ...[{
            key: "da",
            value: this.localizationService.strings.Panel_NavigatorBar_LanguageDanish,
          },
          {
            key: "de",
            value: this.localizationService.strings.Panel_NavigatorBar_LanguageGerman,
          },
          {
            key: "nb",
            value: this.localizationService.strings.Panel_NavigatorBar_LanguageNorwegian,
          },
          {
            key: "sv",
            value: this.localizationService.strings.Panel_NavigatorBar_LanguageSwedish,
          },
          {
            key: "fi",
            value: new LocalizationService().strings.Panel_NavigatorBar_LanguageFinnish,
          },
          {
            key: "nl",
            value: this.localizationService.strings.Panel_NavigatorBar_LanguageDutch,
          }].sort((a, b) => a.value.localeCompare(b.value))
        ]}
        borderRadius={5}
        onChange={(language: string) => {
          this.props.selectedTopItem.config.instance.aiContentLanguage = language;
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
        style={{
          float: "left"
        }}
      />
      <div className={adminStyles.panelDivider} />
      <IASiteSelector
        environment={this.props.navigatorStore.environment}
        label={this.localizationService.strings.Navigator_Admin_SelectedSites}
        tenant={this.props.navigatorStore.tenant}
        higlightColor={this.props.navigatorStore.highlightColor}
        selectedSites={this.props.selectedTopItem.config.instance.aiSites}
        onSitesSelected={(selectedSites: IContentOrganizerCreate[]) => {
          this.props.selectedTopItem.config.instance.aiSites = [...selectedSites];
          this.props.navigatorStore.checkForChanges();
          this.forceUpdate();
        }}
      />
    </>
  }
}